import { Component, OnInit, Input, SimpleChange } from '@angular/core';
import { NavController, App } from 'ionic-angular';
import { MessengerProvider } from '../../providers/messenger/messenger';
import { GroupContacts } from '../../models/user.model';
import { User } from '../../providers/user/user';

/**
 * Generated class for the MessengerContactsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'messenger-contacts',
  templateUrl: 'messenger-contacts.html',
})
export class MessengerContactsComponent implements OnInit {
  contacts: any[];
  keys: any;
  page = 0;
  pageSize = 10;
  totalPages: number = 0;

  @Input('refresh') refresh;
  @Input('search') search: string;

  constructor(
    private app: App,
    private navCtrl: NavController,
    private messengerProvider: MessengerProvider,
    private userProvider: User
  ) {}

  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChange) {
    if (changes['refresh'] !== undefined || changes['search'] !== undefined) {
      this.page = 0;
      this.getContacts(this.search, this.page, this.pageSize);
    }
  }

  getContacts(query, pageNumber, pageSize) {
    this.messengerProvider
      .getContacts(this.search, this.page, this.pageSize)
      .subscribe(res => {
        this.keys = Object.keys(res.groupedData);
        this.contacts = res.groupedData;
        this.page++;
        this.totalPages = res.totalPages;
      });
  }

  viewProfile(userId: string): void {
    if ( userId !== this.userProvider.currentUser().uuid) {
      this.app.getRootNav().push('ProfilePage', {
        userId: userId,
      });
    }
  }
  addNote(contact: any): void {
    this.app.getRootNav().push('NotePage', {
      user: contact,
    });
  }

  viewMessages(userId: string): void {
    this.navCtrl.push('MessagePage', {
      userId: userId,
    });
  }

  doInfinite(infiniteScroll) {
    setTimeout(() => {
      this.messengerProvider
        .getContacts(this.search, this.page, this.pageSize)
        .subscribe(res => {
          const data = res.groupedData;
          this.page++;
          this.totalPages = res.totalPages;
          for (var key in data) {
            if (!this.keys.includes(key)) {
              this.keys.push(key);
              this.contacts[key] = [];
            }
            for (let index = 0; index < data[key].length; index++) {
              this.contacts[key].push(data[key][index]);
            }
          }
          infiniteScroll.complete();
        });
    }, 0);
  }

  goToEventList() {
      this.navCtrl.setRoot('HomePage');
  }

}



// WEBPACK FOOTER //
// ./src/components/messenger-contacts/messenger-contacts.ts